
<template>
  <div class="btn-know ft-16"
    :class="{ dark }"
    @click="btnClick">{{ text }}</div>
</template>

<script>
export default {
  props: {
    dark: Boolean,
    text: String
  },

  methods: {
    btnClick () {
      this.$emit('btn-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-know {
  cursor: pointer;
  width: 166px;
  height: 64px;
  color: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-know.dark {
  color: #03192f;
  border-color: #03192f;
  transition: color 0.4s cubic-bezier(.77,.15,0,.99), background-color 0.4s cubic-bezier(.77,.15,0,.99);
}
.btn-know.dark:hover {
  color: #8fd6ed;
  background-color: #000;
}
</style>
